import { create } from 'zustand';

const STORAGE_KEY_KEYPAD = 'jcalc.keypad.enabled';

function isCoarsePointer(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(pointer: coarse)').matches;
}

function readKeypadPreference(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_KEYPAD);
    if (raw === null) return isCoarsePointer();
    return raw === '1';
  } catch {
    return isCoarsePointer();
  }
}

function writeKeypadPreference(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY_KEYPAD, enabled ? '1' : '0');
  } catch {
    // ignore
  }
}

type PreferencesState = {
  keypadEnabled: boolean;
  setKeypadEnabled: (enabled: boolean) => void;
};

export const usePreferencesStore = create<PreferencesState>((set) => ({
  keypadEnabled: readKeypadPreference(),
  setKeypadEnabled: (enabled) => {
    writeKeypadPreference(enabled);
    set({ keypadEnabled: enabled });
  },
}));
